// extracted by mini-css-extract-plugin
export default {"page":"iX-z","cartModal":"jX-z","checkout":"kX-z","placeholder":"lX-z","account":"mX-z"};